import { instance } from "utils/axios";

export const getConfirmedJobApplicationDetailsServices = async request => {
    return await instance.post('api/wizard/GetConfirmedJobApplicationDetails', request);
};